let numCounters = [];

$(function(){

    if($('.header-banner').length){
        $('.keywords').show();
    } else{
        $('.keywords').first().hide();
        $('main').css('margin-top','100px');
    }
    
    $('.page-id-27 .header-outer-wrap .menu-link').click(function () {
        if ($(this).data('jump').length) {
            console.log($(this).data('jump'));
            $([document.documentElement, document.body]).animate({
                scrollTop: $($(this).data('jump')).offset().top
            }, 1000);
        }
        if ($(this).parents('.mobile').length) {
            $('.hamburger').trigger('click');
        }
    });
    setIframe($('.youtube-video'));

    // corona
    let popup = $('.popup');
    if (localStorage.getItem('corona') === 'true') {
    } else {
        popup.show();
    }
    // popup function
    popup.click(function () {
        localStorage.setItem('corona','true');
        $(this).hide();
    });

    $('.menu-button').click(function () {
        $('body').toggleClass('mobile-menu-open');
    })

    $('.numberCounter').each(function() {
        numCounters.push(this);
    });

    initCounter();


});

$(window).on("load", function (e) {

});

$(window).on("scroll", function (e) {
    initCounter();
});

$(window).on("resize", function (e) {
    setIframe($('.youtube-video'));
});

function setIframe(elem) {
    elem.each(function () {
        let height = $(this).width()/16*9;
        $(this).height(Math.floor(height));
    });
}
function isScrolledIntoView(elem) {

    let docViewTop = $(window).scrollTop();
    let docViewBottom = docViewTop + $(window).height();

    let elemTop = elem.offset().top;
    let elemBottom = elemTop + elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop - 70 >= docViewTop));

}

function initCounter() {
    if($('.numberCounter.activated').length !== $('.numberCounter').length) {
        $.each(numCounters, function() {
            if(isScrolledIntoView($(this).find('.counterColumn:first-child .counter')) || isScrolledIntoView($(this).find('.counterColumn:last-child .counter'))) {
                if(!$(this).hasClass('activated')) {
                    $(this).find('.counterNumber .counter').each(function () {
                        $(this).prop('Counter', 0).animate({
                            Counter: $(this).data('destinationvalue')
                        }, {
                            duration: 800,
                            easing: 'swing',
                            step: function (now) {
                                if($(this).data('destinationvalue') % 1 === 0) {
                                    let num = Math.ceil(now);
                                    $(this).text(num.toLocaleString());
                                } else {
                                    let num = now * 10;
                                    num = Math.round(num);
                                    num = num / 10;
                                    $(this).text(num.toLocaleString());
                                }
                            }
                        });
                    });
                }
                $(this).addClass('activated');
            }
        });
    }
}

